import type { TFootnoteElement } from '@alpod-ai-writer/plate-plugins/footnotes';
import { useFootnoteOpenStateForElement, useFootnotesOffset } from '@alpod-ai-writer/plate-plugins/footnotes/react';
import { cn,withRef } from '@udecode/cn';
import { PlateElement, useFocused, useSelected } from '@udecode/plate/react';
import { useCallback } from 'react';

export const FootnoteElement = withRef<typeof PlateElement, {}>(({
    className,
    children,
    ...props
}, ref) => {
    const element = props.element as TFootnoteElement;

    const footnotesOffset = useFootnotesOffset();
    const { isOpened, open, close } = useFootnoteOpenStateForElement(element);

    const selected = useSelected();
    const focused = useFocused();

    const handleOnClick = useCallback(() => {
        if (isOpened) {
            close();
        } else {
            open();
        }
    }, [ element.ref, isOpened, open, close ]);

    const label = String(footnotesOffset + element.index + 1);

    return (
        <PlateElement
            as={'span'}
            ref={ref}
            className={className}
            data-slate-value={element.ref}
            contentEditable={false}
            draggable
            {...props}
        >
            <span
                className={cn(
                    'inline-block rounded px-1 py-0.5 mx-0.5 text-sm leading-none align-super transition-colors duration-200 cursor-pointer',
                    selected && focused && 'ring-2 ring-ring',
                    !isOpened && 'bg-yellow-200 hover:bg-yellow-300',
                    isOpened && 'bg-blue-200 hover:bg-blue-300'
                )}
                onClick={handleOnClick}
            >{label}</span>
            {children}
        </PlateElement>
    );
});
